function wowInit () {
    new window.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true,
    }).init();
}

export default wowInit;



// WEBPACK FOOTER //
// ./src/modules/plugins/wowInit.js